import Grid from '@mui/material/Grid';
import PasswordCard from "./SectionPassword.jsx/PasswordCard";


export default function PasswordChangeDashboard() {

  return (

    <Grid container spacing={1} sx={{ maxWidth: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <PasswordCard />
    </Grid>

  );
}
